import { loadStripe } from '@stripe/stripe-js';
import { auth } from '../config/firebase';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

export const createCheckoutSession = async () => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User must be logged in to upgrade to Pro');
  }

  try {
    // Call your backend to create a checkout session
    const response = await fetch('/api/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: user.uid,
        email: user.email,
      }),
    });

    const { sessionId } = await response.json();
    
    // Redirect to Stripe checkout
    const stripe = await stripePromise;
    if (!stripe) {
      throw new Error('Stripe failed to load');
    }

    const { error } = await stripe.redirectToCheckout({
      sessionId,
    });

    if (error) {
      throw error;
    }
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

export const checkProStatus = async (): Promise<boolean> => {
  const user = auth.currentUser;
  if (!user) {
    return false;
  }

  try {
    const response = await fetch(`/api/check-pro-status?userId=${user.uid}`);
    const { isPro } = await response.json();
    return isPro;
  } catch (error) {
    console.error('Error checking pro status:', error);
    return false;
  }
}; 